namespace Outstanding {
  export enum API {
    'get_user_outstanding_repayments' = '/fast-escrow/order/get_user_outstanding_repayments',
  }

  export enum RefactorAPI {
    'get_user_outstanding_repayments' = '/fast-escrow/transaction/query_repayment_list',
    // Cache 搜索(BFF 6.13 QueryRepaymentListBySearchBarId)，出参条目与 6.7 列表同构
    // 路径已对齐后端网关(FastEscrow通用中间件，/user/sec 前缀)
    'search_repayment_list' = '/user/sec/fast-escrow/transaction/query_repayment_list_by_search_bar_id',
  }
}

export enum ORDER_STATUS {
  UNPAID = 1,
  PARTIAL_REPAID = 2,
  REPAID = 3,
}

export default Outstanding;
